module.exports = ":host{position:absolute;right:1rem;z-index:99;cursor:pointer}.user-info-wrapper{position:relative}.user-root-title{font-size:14px}.user-root-title::after{content:' ▾'}.user-level-content{position:absolute;background:#fff;font-size:14px;right:0}.user-level-content a{cursor:pointer;display:block;padding:6px 12px;color:#878787;font-size:14px;white-space:nowrap;text-decoration:none}.user-level-content a:hover{color:#09c}.user-root-image{width:25px;height:25px}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/user-info/user-info.component.scss
// module id = ./src/app/shared/user-info/user-info.component.scss
// module chunks = main